import Icon from '@ant-design/icons';
import React from 'react';

const GrokSvg: React.FC = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M5.2 17.8c4.7-1.1 8.3-4.7 9.4-9.4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
    />
    <path
      d="M18.8 6.2c-4.7 1.1-8.3 4.7-9.4 9.4"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      opacity="0.65"
    />
    <path
      d="M8 6.8h8"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      opacity="0.9"
    />
    <path
      d="M6.8 8v8"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.2"
      strokeLinecap="round"
      opacity="0.9"
    />
  </svg>
);

export const GrokIcon: React.FC<{ className?: string }> = ({ className }) => {
  return <Icon component={GrokSvg} className={className} />;
};

